"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateReviewSchema = void 0;
var zod_1 = require("zod");
var types_1 = require("./types");
var RewardInfo = zod_1.z.object({
    /** 리워드 정보 (3,000C) */
    primary: zod_1.z.string(),
    /** 부가 리워드 정보 (1,000P) */
    secondary: zod_1.z.string().optional(),
});
var CreateReviewDataSuccessSchema = types_1.MutateReviewDataSuccessSchema.extend({
    /** 리워드 정보 */
    rewardInfo: RewardInfo,
});
var CreateReviewDataFailedSchema = types_1.MutateReviewDataFailedSchema;
var CreateReviewDataSchema = zod_1.z.union([CreateReviewDataSuccessSchema, CreateReviewDataFailedSchema]);
/**
 * 후기 작성 완료 응답
 */
exports.CreateReviewSchema = zod_1.z.object({
    data: CreateReviewDataSchema,
});
